module.exports = __webpack_public_path__ + "static/inc-logo-edb2ebe2bdb0cca56fe9e096e3e2c861.svg";